module.exports = __webpack_public_path__ + "img/how-work-3.05b85989.png";